import { render, staticRenderFns } from "./customs-fee.vue?vue&type=template&id=317bc2d0"
import script from "./customs-fee.vue?vue&type=script&lang=ts"
export * from "./customs-fee.vue?vue&type=script&lang=ts"
import style0 from "./customs-fee.vue?vue&type=style&index=0&id=317bc2d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports